import type { NavSectionProps } from "src/components/nav-section";

import { paths } from "src/routes/paths";

import { CONFIG } from "src/global-config";

import { SvgColor } from "src/components/svg-color";
import { MdSettings } from 'react-icons/md'
import { MdSystemUpdate } from 'react-icons/md'
// ----------------------------------------------------------------------

const icon = (name: string) => (
  <SvgColor src={`${CONFIG.assetsDir}/assets/icons/navbar/${name}.svg`} />
);

const ICONS = {
  job: icon("ic-job"),
  blog: icon("ic-blog"),
  chat: icon("ic-chat"),
  mail: icon("ic-mail"),
  user: icon("ic-user"),
  file: icon("ic-file"),
  lock: icon("ic-lock"),
  tour: icon("ic-tour"),
  order: icon("ic-order"),
  label: icon("ic-label"),
  blank: icon("ic-blank"),
  kanban: icon("ic-kanban"),
  folder: icon("ic-folder"),
  course: icon("ic-course"),
  banking: icon("ic-banking"),
  booking: icon("ic-booking"),
  invoice: icon("ic-invoice"),
  survey: icon("ic-survey"),
  product: icon("ic-product"),
  calendar: icon("ic-calendar"),
  disabled: icon("ic-disabled"),
  external: icon("ic-external"),
  menuItem: icon("ic-menu-item"),
  ecommerce: icon("ic-ecommerce"),
  analytics: icon("ic-analytics"),
  dashboard: icon("ic-dashboard"),
  parameter: icon("ic-parameter"),
  subscription: <MdSettings />,
  appVersion: <MdSystemUpdate />,
};

// ----------------------------------------------------------------------

export const navData: NavSectionProps["data"] = [
  /**
   * Overview
   */
  {
    subheader: "App",
    items: [
      {
        title: "Dashboard",
        path: paths.dashboard.root,
        icon: ICONS.dashboard,
      },
      { title: "Users", path: paths.dashboard.user, icon: ICONS.user },
      {
        title: "Restaurants",
        path: paths.dashboard.restaurants,
        icon: ICONS.tour,
      },
      {
        title: "Bookings",
        path: paths.dashboard.booking,
        icon: ICONS.booking,
      },
       {
        title: "Revenue",
        path: paths.dashboard.revenue,
        icon: ICONS.invoice,
      },{
        title: "Survey",
        path: paths.dashboard.survey,
        icon: ICONS.survey,
      },
      {
        title: "App Version",
        path: paths.dashboard.appVersion,
        icon: ICONS.appVersion,
      },
      // {
      //   title: "Subscription",
      //   path: paths.dashboard.subscription,
      //   icon: ICONS.subscription,
      // },
    ],
  },
  /**
   * Settings
   */
  {
    subheader: "Settings",
    items: [
      // {
      //   title: "Group",
      //   path: paths.dashboard.group.root,
      //   icon: ICONS.user,
      //   children: [
      //     { title: "Four", path: paths.dashboard.group.root },
      //     { title: "Five", path: paths.dashboard.group.five },
      //     { title: "Six", path: paths.dashboard.group.six },
      //   ],
      // },
      {
        title: "Change Password",
        path: paths.dashboard.changePassword,
        icon: ICONS.lock,
      },
      { title: "Logout", path: "#", icon: ICONS.external },
    ],
  },
];
